<template>
  <div>
    <div class="container-fluid mt-5">
      <div class="vx-row">
        <div class="vx-col w-full">
          <vx-card title="Solicitantes candidatos a domiciliación">
            <div class="skinny row">
              <div class="col-md-2">
                <vs-select placeholder="Seleccione" multiple label="Tipo de contrato" class="w-full"
                  v-model="contractTypes">
                  <vs-select-item :key="index" :value="item.value" :text="item.text"
                    v-for="(item, index) in contractTypeOptions" />
                </vs-select>
              </div>
              <div class="col-md-4">
                <vs-select placeholder="Seleccione" multiple label="Estatus de contrato" class="w-full"
                  v-model="contractStatuses">
                  <vs-select-item :key="index" :value="item.value" :text="item.text"
                    v-for="(item, index) in contractStatusOptions" />
                </vs-select>
              </div>
              <div class="col-md-2">
                <div class="flex flex-wrap">
                  <vs-button v-if="!loading" @click="getProjects" color="dark" class="mt-6 mr-1">Filtrar</vs-button>
                </div>
              </div>
            </div>
            <vs-table pagination ref="applicantsTable" stripe class="mt-5" :max-items="80" :data="projects"
              noDataText="No hay datos disponibles">
              <template slot="thead">
                <vs-th class="bold" v-for="(col, idx) in columns" v-bind:key="idx"
                  :sort-key="col.sortable ? col.key : null">{{ col.title }}</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                  <!-- <vs-td><vs-button color="primary" :to="{path:'/cobranza/' + tr.project_id}" type="flat">{{ tr.project_id }}</vs-button></vs-td> -->
                  <vs-td>{{ tr.clientId }}</vs-td>
                  <vs-td>
                    {{ tr.name }}<br>
                    <a :href="'mailto:' + tr.email">{{ tr.email }}</a><br>
                    Tel: {{ tr.phone }}<br>
                  </vs-td>
                  <vs-td>{{ tr.projectIds }}</vs-td>
                  <vs-td v-if="tr.contracts.length > 0">
                    <vs-table ref="contractsTable" :data="tr.contracts" noDataText="No hay datos disponibles">
                      <template slot-scope="{ data }">
                        <vs-tr :key="indextr" v-for="(contract, indextr) in data" :data="contract">
                          <vs-td class="small">
                            <vx-tooltip text="Id de contrato de cliente.">
                              CCID: {{ contract.id }}
                            </vx-tooltip>
                          </vs-td>
                          <vs-td class="small">{{ contract.name }}</vs-td>
                          <vs-td class="small">Versión: {{ contract.version }}</vs-td>
                          <vs-td class="small" v-if="contract.status && contract.status == 1"><vs-chip
                              color="dark">Firmado</vs-chip></vs-td>
                          <vs-td class="small"
                            v-else-if="contract.client_contract_status == 'signed' || contract.client_contract_status == 'verified'"><vs-button
                              color="success" size="small"
                              @click="newDirectBilling(tr, contract.id)">Generar</vs-button></vs-td>
                          <vs-td class="small" v-else><vs-chip color="danger">No firmado</vs-chip></vs-td>
                        </vs-tr>
                      </template>
                    </vs-table>
                  </vs-td>
                  <vs-td v-else><small>Sin contratos</small></vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </vx-card>
        </div>
      </div>
      <vs-popup title="Generar Domiciliación" :active.sync="popupNewDirectBillingActive">
        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="con-exemple-prompt">
              <h5 class="ml-1 bold">Datos del solicitante:</h5>
              <label class="ml-1"><strong>Cid:</strong> {{ applicantSelected.clientId }}</label><br>
              <label class="ml-1"><strong>Nombre:</strong> {{ applicantSelected.name }}</label><br>
              <label class="ml-1"><strong>Monto máximo:</strong>
                ${{ formatPrice(applicantSelected.maxAmount) }}</label><br>
              <label class="ml-1 mt-3"><strong>Cuentas bancarias verificadas</strong></label>
              <vs-select class="lg:w-4/5 mb-2" v-model="applicantBankAccountSelectedId"
                placeholder="Seleccione una opción">
                <vs-select-item :key="index" :value="item.id" :text="'(' + item.bank.short_name + ') ' + item.clabe"
                  v-for="(item, index) in applicantBankAccounts" />
              </vs-select>
              <vs-button class="mt-5 mb-5" color="success" size="small"
                @click="createDirectBilling()">Generar</vs-button>
            </div>
          </div>
        </div>
      </vs-popup>
    </div>
  </div>

</template>

<script lang="js">
import dateHelper from "@mixins/dateHelper";
import { formatPrice, formatMoney } from '../../../components/admin/filters.js';
import Toasted from 'vue-toasted';
import * as moment from 'moment'
import { BankAccountStatus } from "@/models/BankAccountStatus";

const columnDefinitions = [
  { title: "CID", key: "client_id", sortable: false },
  { title: "CLIENTE", key: "client", sortable: false },
  { title: "PIDs", key: "pids", sortable: false },
  { title: "CONTRATOS DE DOMICILIACIÓN", key: "contracts", sortable: false },
];
export default {
  name: 'dashboard',
  props: [],
  mixins: [dateHelper],
  async mounted() {
    await this.getProjects();
  },
  data() {
    return {
      columns: columnDefinitions,
      projects: [],
      count: 0,
      total: 0,
      loading: false,
      popupNewDirectBillingActive: false,
      clienContractSelectedId: null,
      applicantSelected: {
        clientId: null,
        name: null,
        maxAmount: null,
      },
      applicantBankAccounts: [],
      applicantBankAccountSelectedId: null,
      showing: '',
      contractStatuses: ['signed', 'verified'],
      contractStatusOptions: [
        // {text:'Generado',value:'generated'},
        // {text:'Enviado',value:'sent'},
        { text: 'Firmado', value: 'signed' },
        { text: 'Verificado', value: 'verified' }
      ],
      contractTypes: [19],
      contractTypeOptions: [
        // {text:'Domiciliación HSBC',value:13},
        // {text:'Domiciliación Pretmex',value:16},
        { text: 'Domiciliación BanBajío', value: 19 }
      ],
    }
  },
  methods: {
    formatPrice,
    async getProjects() {
      this.showLoading(true);
      this.projects = [];
      await axios.post('/api/cobranza/directBillingReport', {
        contractTypes: this.contractTypes,
        contractStatuses: this.contractStatuses
      }).then(response => {
        this.projects = response.data;
        this.showLoading(false);
      }).catch(error => {
        this.showLoading(false);
      });
    },
    newDirectBilling(applicant, contract_id) {
      this.applicantSelected = applicant;
      this.clienContractSelectedId = contract_id;
      this.getApplicantBankAccounts(this.applicantSelected.userId);
      this.popupNewDirectBillingActive = true;
    },
    async getApplicantBankAccounts(userId) {
      this.showLoading(true);
      await axios.get('/api/backoffice/bank-account/' + userId).then(response => {
        this.applicantBankAccounts = response.data.filter((fg) => fg.verified === BankAccountStatus.VERIFIED)
      });
      this.showLoading(false);
    },
    async createDirectBilling() {
      if (!this.applicantBankAccountSelectedId) {
        this.warningNotif('Cuenta bancaria', 'Debes seleccionar una cuenta de banco');
        return;
      }
      this.showLoading(true);
      let payload = {
        clientId: this.applicantSelected.clientId,
        bankAccountId: this.applicantBankAccountSelectedId,
        clientContractId: this.clienContractSelectedId,
        directBillingMaxAmount: this.applicantSelected.maxAmount
      };
      await axios.post('/api/cobranza/createApplicantDirectBilling', payload).then(response => {
        this.popupNewDirectBillingActive = false;
        this.clienContractSelectedId = null;
        this.applicantBankAccountSelectedId = null;
        this.showLoading(false);
        this.getProjects();
      }).catch(error => {
        this.showLoading(false);
        if (error.response.data.message != undefined) {
          this.errorNotif("Aviso", error.response.data.message, 4000);
        } else {
          this.errorNotif("Aviso", 'Ha ocurrido un error intente mas tarde.', 4000);
        }
      });
    }
  }
}
</script>